<template>
  <div class="qianchuan container">
    <div
      class="s-item"
      :class="{
        hide: hideItem && item.title == '推广预期',
      }"
      v-for="(item, idx) in items"
      :key="idx"
    >
      <p class="title">{{ item.title }}</p>
      <div
        class="item"
        :class="{
          active: form[item.type] == o.title,
          hide: hide && o.title == '极速推广',
        }"
        v-for="(o, i) in item.options"
        :key="i"
        @click="form[item.type] = o.title"
      >
        <el-image
          v-if="item.title == '营销目标'"
          style="width: 36px; height: 36px"
          :src="o.icon"
          fit="fit"
        ></el-image>
        <p class="item-title">{{ o.title }}</p>
        <p class="item-content">{{ o.content }}</p>
      </div>
    </div>

    <button class="btn" @click="handleSet">新建计划</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        target: "短视频/图文带货",
        scene: "通投广告",
        extensionMode: "极速推广",
        expect: "快速推",
      },
      items: [
        {
          type: "target",
          title: "营销目标",
          options: [
            {
              icon: require("@/assets/images/simulation/icon_video.svg"),
              title: "短视频/图文带货",
              content: "吸引用户直接购买",
            },
            {
              icon: require("@/assets/images/simulation/icon_live.svg"),
              title: "直播带货",
              content: "吸引用户进入直播间",
            },
          ],
        },
        {
          type: "scene",
          title: "营销场景",
          options: [
            {
              title: "通投广告",
              content:
                "根据你的投放目标智能优选网络平台或流量场景（信息流/搜索），并优化素材内容和格式，以便寻找对你的商品感兴趣的用户并适配展示广告。",
            },
            {
              title: "搜索广告",
              content:
                "根据你的投放目标智能优选网络平台或流量场景，并优化素材内容和格式，以便向主动对你的商品表达兴趣的用户展示广告。",
            },
          ],
        },
        {
          type: "extensionMode",
          title: "推广方式",
          options: [
            {
              title: "极速推广",
              content:
                "只需设置预算、出价等关键要素即可投放，支持基础的定向人群选择",
            },
            {
              title: "专业推广",
              content: "可自定义更多投放和创意设置，支持更丰富的定向人群选择",
            },
          ],
        },
        {
          type: "expect",
          title: "推广预期",
          options: [
            {
              title: "快速推",
              content:
                "快速推广，只需设置预算、出价等即可投放，支持基础的定向人群选择，与原极速推广功能一致",
            },
          ],
        },
      ],
      hide: false,
    };
  },
  watch: {
    "form.scene"(val) {
      this.hide = val == "搜索广告";
      this.form.extensionMode = val == "搜索广告" ? "专业推广" : "极速推广";
    },
  },
  computed: {
    hideItem() {
      return (
        this.form.target != "直播带货" ||
        this.form.scene != "通投广告" ||
        this.form.extensionMode != "极速推广"
      );
    },
  },
  methods: {
    handleSet() {
      let path;
      if (
        this.form.target == "短视频/图文带货" &&
        this.form.scene == "通投广告" &&
        this.form.extensionMode == "极速推广"
      ) {
        path = "/simulation/qianchuan/videoLite";
      } else if (
        this.form.target == "直播带货" &&
        this.form.scene == "通投广告" &&
        this.form.extensionMode == "极速推广"
      ) {
        path = "/simulation/qianchuan/liveLite";
      } else if (
        this.form.target == "短视频/图文带货" &&
        this.form.scene == "搜索广告" &&
        this.form.extensionMode == "专业推广"
      ) {
        path = "/simulation/qianchuan/searchVideoStandard";
      } else if (
        this.form.target == "直播带货" &&
        this.form.scene == "搜索广告" &&
        this.form.extensionMode == "专业推广"
      ) {
        path = "/simulation/qianchuan/searchLiveStandard";
      } else if (
        this.form.target == "短视频/图文带货" &&
        this.form.scene == "通投广告" &&
        this.form.extensionMode == "专业推广"
      ) {
        path = "/simulation/qianchuan/createVideoStandard";
      } else if (
        this.form.target == "直播带货" &&
        this.form.scene == "通投广告" &&
        this.form.extensionMode == "专业推广"
      ) {
        path = "/simulation/qianchuan/createLiveStandard";
      }

      this.$router.push({ path, query: { form: JSON.stringify(this.form) } });
    },
  },
};
</script>

<style lang="less" scoped>
.qianchuan {
  padding: 0 200px;
  text-align: left;
  .s-item {
    &.hide {
      display: none;
    }
    .title {
      margin-top: 28px;
      margin-bottom: 16px;
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;
      color: #333;
    }
    .item {
      display: inline-block;
      margin-right: 15px;
      width: 272px;
      padding: 18px 24px;
      border: 1px solid transparent;
      border-radius: 4px;
      background-color: #f2f2f2;
      cursor: pointer;
      user-select: none;
      &:hover {
        background-color: #edf1fd;
      }
      &.active {
        border: 1px solid #194ce5;
        border-radius: 3px;
        background-color: #fff;
        box-shadow: 0 0 2px rgba(0 0 0 / 10%);
      }
      &.hide {
        display: none;
      }
      .item-title {
        margin-top: 3px;
        line-height: 20px;
        font-weight: 500;
        font-size: 14px;
        color: #333;
      }
      .item-content {
        margin-top: 8px;
        line-height: 17px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.4);
      }
    }
  }
  .btn {
    margin-top: 45px;
    width: 114px;
    color: #fff;
    padding: 5px 16px;
    font-size: 14px;
    line-height: 22px;
    border-radius: 4px;
    background-color: #194ce5;
    border-color: #194ce5;
    &:hover {
      background-color: #436dea;
      border-color: #436dea;
    }
  }
}
</style>